<template>
  <SentimentGauge
    :title="title"
    :item-id="itemId"
    :owner-posts="false"
    v-bind="$attrs"
  />
</template>

<script>
import SentimentGauge from '@/components/cards/SentimentGauge';

export default {
  name: 'NpsGauge',
  components: {
    SentimentGauge,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
</style>
